import React from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ja from 'date-fns/locale/ja'
registerLocale('ja', ja)

const DateSelector = props => {
  return (
    <div className='selectConditions searchList isActivityDate'>
      <DatePicker
        dateFormat="yyyy/MM/dd"
        selected={props.startDate ? new Date(props.startDate) : null}
        onChange={date => props.setStartDate(moment(date).format('YYYY-MM-DD'))}
        placeholderText="開始日"
        locale="ja"
      />
      <span>〜</span>
      <DatePicker
        dateFormat="yyyy/MM/dd"
        selected={props.endDate ? new Date(props.endDate) : null}
        onChange={date => props.setEndDate(moment(date).format('YYYY-MM-DD'))}
        placeholderText="終了日"
        locale="ja"
      />
    </div>
  )
}

export default DateSelector;